import React from 'react';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import TradingAccountAuction from '../../containers/TradingAccount/TradingAccountAuction';

class AddTsAuctionView extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        type: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  render() {
    const { t } = this.props;
    const type = this.props.match.params.type;

    return (
      <Layout className="main-container">
        <h1 className="mb-3">{t('titleSendToAuction')}</h1>
        <TradingAccountAuction t={t} type={type} />
      </Layout>
    );
  }
}

export default withTranslation(NAMESPACES.tradingAccount)(AddTsAuctionView);
